import styled, { css } from 'styled-components';
import { colors, radii, fonts } from '../designSystem';

const AnnuaireButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: ${radii.button};
  font-family: ${fonts.body};
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  ${(p) =>
    p.$variant === 'primary' &&
    css`
      background-color: ${colors.vert};
      color: ${colors.bleuFonce};

      &:hover {
        box-shadow: 0 4px 12px rgba(213, 255, 79, 0.4);
      }
    `}

  ${(p) =>
    p.$variant === 'secondary' &&
    css`
      background-color: ${colors.bleuFonce};
      color: ${colors.white};

      &:hover {
        box-shadow: 0 4px 12px rgba(49, 73, 89, 0.3);
      }
    `}

  ${(p) =>
    p.$variant === 'outline' &&
    css`
      background-color: transparent;
      color: ${colors.bleu};
      border: 1.5px solid ${colors.bleu};

      &:hover {
        background-color: ${colors.bleuPastel};
      }
    `}
`;

AnnuaireButton.defaultProps = {
  $variant: 'primary',
};

export default AnnuaireButton;
